var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"work-foto"},[(_vm.showLoading)?_c('Loading',{attrs:{"inside-container":true}}):_vm._e(),_c('FadeUp',{attrs:{"src":_vm.foto.foto,"src-placeholder":require('@/assets/img/default-img.jpg')},on:{"load":function($event){return _vm.imageLoaded()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }